import React from "react";

const SwapIcon = () => {
    return (
        <svg
            width="127"
            height="86"
            viewBox="0 0 127 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17 53C17 51.8954 16.1046 51 15 51C13.8954 51 13 51.8954 13 53H17ZM113.414 51.5858C112.633 50.8047 111.367 50.8047 110.586 51.5858L97.8579 64.3137C97.0768 65.0948 97.0768 66.3611 97.8579 67.1421C98.6389 67.9232 99.9052 67.9232 100.686 67.1421L112 55.8284L123.314 67.1421C124.095 67.9232 125.361 67.9232 126.142 67.1421C126.923 66.3611 126.923 65.0948 126.142 64.3137L113.414 51.5858ZM13 53V59.25H17V53H13ZM39 85.25H88V81.25H39V85.25ZM114 59.25V53H110V59.25H114ZM88 85.25C102.359 85.25 114 73.6094 114 59.25H110C110 71.4003 100.15 81.25 88 81.25V85.25ZM13 59.25C13 73.6094 24.6406 85.25 39 85.25V81.25C26.8497 81.25 17 71.4003 17 59.25H13Z"
                fill="#1E1E1E"
            />
            <path
                d="M110 33C110 34.1046 110.895 35 112 35C113.105 35 114 34.1046 114 33H110ZM13.5858 34.4142C14.3668 35.1953 15.6332 35.1953 16.4142 34.4142L29.1421 21.6863C29.9232 20.9052 29.9232 19.6389 29.1421 18.8579C28.3611 18.0768 27.0948 18.0768 26.3137 18.8579L15 30.1716L3.68629 18.8579C2.90524 18.0768 1.63891 18.0768 0.857864 18.8579C0.0768158 19.6389 0.0768158 20.9052 0.857864 21.6863L13.5858 34.4142ZM114 33V26H110V33H114ZM88 0H39V4H88V0ZM13 26V33H17V26H13ZM39 0C24.6406 0 13 11.6406 13 26H17C17 13.8497 26.8497 4 39 4V0ZM114 26C114 11.6406 102.359 0 88 0V4C100.15 4 110 13.8497 110 26H114Z"
                fill="#1E1E1E"
            />
        </svg>
    );
};

export default SwapIcon;
